import React, { useState } from "react";
import SendIcon from "@mui/icons-material/Send";
import axios from "axios";
import { useMediaQuery, Button } from "@mui/material";

import { useLanguage } from "../context/LanguageContext.js";

import { logDev } from "../utils/logger.js";

const BoutonEnvoyerLienPageList = ({ groupeId, destinataires, nomGroupe, emojiGroupe, snackbar, setSnackbar, disabled = false }) => {
  const { t, locale  } = useLanguage();
  const [loading, setLoading] = useState(false);
  const [cooldown, setCooldown] = useState(false);
  const isMobile = useMediaQuery("(max-width:600px)");

  const handleSend = async () => {

    if (cooldown) { 
      setSnackbar({ 
        open: true, 
        message: t("PleaseWaitBeforeSendingAgain"), 
        severity: "info" 
      }); 
      return; 
    }

    setCooldown(true); 
    setLoading(true);

    try {
      const res = await axios.post(`${process.env.REACT_APP_API}/emails/pageList`, {
        groupeId,
        destinataires,
        nomGroupe,
        emojiGroupe,
        langue: locale || "fr" ,
        lien: `${window.location.origin}/pagelist/${groupeId}`
      });

      logDev("📤 Lien PageList envoyé", res.data);
      
      setSnackbar({
        open: true,
        message: t("PageListLinkSentSuccess"),
        severity: "success"
      });

    } catch (err) {
      logDev("❌ Erreur envoi lien PageList", { message: err.message, stack: err.stack });
      
      setSnackbar({
        open: true,
        message: t("PageListLinkSentError"),
        severity: "error"
      });

    } finally {
      setLoading(false);
      setTimeout(() => setCooldown(false), 60000); // 60 secondes
    }
  };

  return (
    <Button
      variant="contained"
      startIcon={<SendIcon />}
      onClick={handleSend}
      disabled={disabled}
      sx={{
        backgroundColor: "#4CAF50 !important",
        color: "#fff !important",
        fontWeight: "bold",
        fontSize: isMobile ? "0.5rem" : "0.7rem",
        padding: "10px 20px",
        borderRadius: 1,
        "&:hover": {
          backgroundColor: "#388E3C",
          transform: "scale(1.05)"
        }
      }}
    >
      {t("SendPageListLink")}
    </Button>
  );
};

export default BoutonEnvoyerLienPageList;
